export default "__VITE_ASSET__CSvX$zpi__"